<h2 mat-dialog-title>Select Excel Sheet</h2>
<div mat-dialog-content>
  <p>Please select a sheet from this Excel file:</p>
  
  <mat-radio-group [(ngModel)]="selectedTab" class="tab-radio-group">
    <mat-radio-button *ngFor="let tab of data.tabs" [value]="tab" class="tab-radio-button">
      {{tab}}
    </mat-radio-button>
  </mat-radio-group>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancelClick()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onConfirmClick()" [disabled]="!selectedTab">
    Confirm
  </button>
</div> 